import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ITask, TaskConversationState } from '@nimbus-assistant/models/task.model';
import { TranslationKeys } from '@nimbus-library/features/localization/models/enums/translation-keys.enum';
import { PortalTranslationKeys } from '@nimbus-library/features/localization/models/enums/portal-translation-keys.enum';
import { FooterInfoComponent } from '../shared/info/footer-info.component';
import { FooterActionsComponent, TaskActionsMode } from '../shared/actions/footer-actions.component';

@Component({
  standalone: true,
  selector: 'app-footer-connected',
  templateUrl: './footer-connected.component.html',
  styleUrls: ['./footer-connected.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FooterInfoComponent, FooterActionsComponent],
})
export class FooterConnectedComponent {
  @Input({ required: true }) public task: ITask;

  public readonly TaskActionsMode = TaskActionsMode;

  public get statusText(): string {
    switch (this.task?.conversationState) {
      case TaskConversationState.PutOnHold:
        return PortalTranslationKeys.AssistantSessionFooterConversationStatePutOnHold;
      case TaskConversationState.DialingOut:
        return PortalTranslationKeys.GeneralUserInteractionOutcomeDialingOut;
      default:
        return TranslationKeys.GeneralConnected;
    }
  }
}
